import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Table
} from "reactstrap";
import swal from 'sweetalert';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import axios from "axios";
import {base_api_url} from "variables/general.js";
import $ from "jquery";
import datepickerFactory from 'jquery-datepicker';

function getData() {

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let urlTarget = base_api_url + '/api/v1/nc/getnotebyid?notesId=' + params.id; 
  return axios.get(urlTarget).then(res => {
    let data = res.data.response;
    localStorage.setItem("detailHostFamilyNote" + params.id, JSON.stringify(res.data.response));
    $("#hf_family_name").val(data.submittersname);
    $("#hf_reason").val(data.reason);
    $("#hf_notes").val(data.notes);
    $("#hf_student_name").val(data.studentname);
    $("#br_name").html(data.submittersname);
  })
}

function submitData() {

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  var date = new Date();
  var timestamp = date.toISOString();

  let requestData = JSON.parse(localStorage.getItem("detailHostFamilyNote" + params.id));
  requestData["notes"] = $("#hf_notes").val();
  requestData["studentname"] = $("#hf_student_name").val();
  requestData["reason"] = $("#hf_reason").val();
  requestData["submittersname"] = $("#hf_family_name").val();
  requestData["timestamp"] = timestamp;

  return axios.put(base_api_url + "/api/v1/nc/updatebynotesid", requestData).then(res => {
    swal("Success","Successfully update data!","success");
    setTimeout(function(){
      window.location.reload();
    },500);
  }).catch(function (error) {
    swal("Failed!", "Something went wrong!", "error");
  });
}

class HostFamilyNoteDetail extends React.Component {
  componentDidMount(){

    datepickerFactory($);
    $(document).on("click",".btn-csconfirm",function(e){
      e.preventDefault();

      $(".errorCs").remove();
      
      let notValid = 0;
      let msgval = "";
      let cv;

      $.each($('form input'), function(index, formField) {
        if ($(formField).val()==="") {
          cv = $(formField).parent().find("label").text();
          if (cv!=="") {
            msgval = cv + " is required! <br/>";
            $(formField).parent().append("<span class='errorCs'>" + msgval + "</span>");
            notValid += 1;
          }
        }
      });

      if (notValid>0) {
        //$("#msgValidation").show();
      } else {
        submitData();
      }
      
    });

    $(document).on("click",".close",function(){
      $(this).parent().parent().hide();
    });

    getData()

  }

  render() {
    return (
      <>
        <PanelHeader size="sm"
          content={
            <div className="content">
              <div className="header text-left">
                <span className="panelHeaderDesc">View and manage Host Family notes.</span>
                <nav aria-label="breadcrumb" role="navigation">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/admin/overview">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="/admin/report/standard-report">Standard Reports</a></li>
                    <li class="breadcrumb-item"><a href="/admin/report/standard-report/host-family-note">Host Family Notes</a></li>
                    <li class="breadcrumb-item active" aria-current="page" id="br_name"></li>
                  </ol>
                </nav>
              </div>
            </div>
          }
        />
        <br/>
        <div className="content">
          <Form name="formsubmit" id="formsubmit" action="/" className="form-horizontal" method="post">
            <Row>
              <Col md="3">
                <Card className="card-chart">
                  <CardBody>
                    <Table responsive>
                      <tbody>
                        <tr>
                          <td className="td-noborder">
                            <a href="#c_h_n" className="anchorItemDetail">Host Family Notes</a>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
              <Col md="9">
                <Card id="c_h_n">
                  <CardHeader>
                    <CardTitle tag="h4" className="panelTitle">Host Family Notes</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        <FormGroup>
                          <h4 className="subHeaderBlue">Host Family Notes</h4>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input readonly="true" id="hf_family_name" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">Family Name</label>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input id="hf_reason" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">Reason</label>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input id="hf_student_name" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">Student Name</label>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input id="hf_notes" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">Notes</label>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row>
                  <Col sm="12">
                    <div className="pull-right">
                      <button className="btn-csconfirm">Update Changes</button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </>
    );
  }
}

export default HostFamilyNoteDetail;
